export const SDK_VERSION = '7.24.2';
